export const CONSENT_GEO_KEY = 'cm_geo_consent_required';
